<script setup lang="ts">
/**
 * Wrapper local autour de @donoor/ui/campaign/CampaignCountdown.vue.
 * Le composant vit dans le package partagé (source unique) ; ce wrapper
 * existe pour que l'auto-import Nuxt (qui ne scanne pas node_modules) le
 * trouve sous son nom habituel — même motif que les autres composants de la
 * page cagnotte.
 */
import CampaignCountdown from "@donoor/ui/campaign/CampaignCountdown.vue";
</script>

<template>
  <CampaignCountdown v-bind="($attrs as any)" />
</template>
